package dev.moetz.chatoverlay.model

import kotlinx.serialization.Serializable
import kotlin.jvm.JvmInline

@JvmInline
@Serializable
value class BroadcasterId(val id: String)
